import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { Navigation } from './components/Navigation/Navigation';
import { Home } from './pages/Home/Home';
import { About } from './pages/About/About';
import { Projects } from './pages/Projects/Projects';
import { Contact } from './pages/Contact/Contact';
import { SchoolPortfolio } from './pages/SchoolPortfolio/SchoolPortfolio';
import { SchoolProjectDetail } from './pages/SchoolProjectDetail/SchoolProjectDetail';
import { PortfolioEntries } from './pages/PortfolioEntries/PortfolioEntries';
import { Admin } from './pages/Admin/Admin';
import { AdminProvider } from './context/AdminContext';
import styles from './App.module.css';

function AppContent() {
  const location = useLocation();
  const isHome = location.pathname === '/';
  const isAdmin = location.pathname === '/admin';
  const school = location.pathname.startsWith('/school')

  return (
    <div className={styles['app-container']}>
      {!isHome && !isAdmin && !school && (
        <nav className={styles.nav}>
          <Navigation />
        </nav>
      )}
      <main className={styles.main}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/school-portfolio" element={<SchoolPortfolio />} />
          <Route path="/school-project/:id" element={<SchoolProjectDetail />} />
          <Route path="/portfolio-entries" element={<PortfolioEntries />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/admin" element={<Admin />} />

          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </main>
      {!isHome && !isAdmin && !school &&(
        <footer className={styles.footer}>
          <p className={styles['footer-text']}>
            © 2026 Ondřej Wislocki
          </p>
        </footer>
      )}
    </div>
  );
}

function App() {
  return (
    <Router>
      <AdminProvider>
        <AppContent />
      </AdminProvider>
    </Router>
  );
}

export default App;
